import { getQuestionsByPoll, getCatalogComponents, getCatalogQuestion, getGroupOptions, saveQuestionByPoll, deleteQuestion } from "actions/WorkFlowActions";
import Loader from "components/UI/Loader";
import React, { useEffect, useState } from "react";
import { FaRegSave } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import { notify } from "utils";
import { MdDelete } from "react-icons/md";
import { ModalConfirm } from "./ModalConfirm";
import Select from 'react-select';

const customStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px',
    overflowY: 'auto',
  }),
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: 'black'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#e0e0e0'
      : state.isFocused
        ? '#f5f5f5'
        : 'white',
    color: '#000',
  }),
};

const ModalHeader = ({ title, onClose }) => (
  <div className="h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg">
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    <IoCloseCircleOutline onClick={onClose} className='text-white text-4xl cursor-pointer' />
  </div>
)

const ModalBody = ({ pollSelected }) => {
  const [isLoading, setIsLoading] = useState(true);
  //Data
  const [questions, setQuestions] = useState([]);
  const [form, setForm] = useState({
    question: "",
    idComponent: 0,
    idGroup: 0,
    required: false,
  });
  const [idSelected, setIdSelected] = useState(0);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [isHaveResponse, setIsHaveResponse] = useState(false);

  //Selects
  const [components, setComponents] = useState([]);
  const [catalogQuestions, setCatalogQuestions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);

  useEffect(() => {
    async function loadData() {
      try {
        const [questionsResponse, componentsResponse, catalogQuestionsResponse, groupOptionsResponse] = await Promise.all([
          getQuestionsByPoll(pollSelected),
          getCatalogComponents(),
          getCatalogQuestion(),
          getGroupOptions()
        ]);
        setQuestions(questionsResponse ?? []);
        setComponents(componentsResponse ?? []);
        setCatalogQuestions(catalogQuestionsResponse ?? []);
        setGroupOptions(groupOptionsResponse ?? []);
        if (catalogQuestionsResponse?.length > 0) {
          setSelectOptions(catalogQuestionsResponse.filter(item => item.active).map(item => ({ label: item.description, value: item.id })))
        }
      } catch (error) {
        console.log(error)
      } finally {
        setIsLoading(false);
      }
    }
    loadData();
  }, [pollSelected]);

  const isValidQuestion = (questions, idQuestion, idComponent) => {
    if (questions.length === 0) return false;

    const exitsQuestion = questions.find(item => item.idQuestion === +idQuestion && item.idComponent === +idComponent);
    return exitsQuestion;
  }

  const handleSave = async () => {
    if (form.question === "") return notify("warning", "Pregunta es requerida", 3000);
    if (form.idComponent === "") return notify("warning", "Tipo de pregunta requerida", 3000);
    if (isHaveResponse && form.idGroup === "") return notify("warning", "Respuesta es requerida", 3000);
    if (isValidQuestion(questions, form.question, form.idComponent)) return notify("warning", "Ya existe una pregunta con ese tipo", 3000);

    const questionSelected = catalogQuestions.find(item => item.id === +form.question);
    const data = {
      idParent: 0,
      idParentAnswer: 0,
      question: questionSelected.description,
      idComponent: form.idComponent,
      idGroup: form.idGroup === "" ? null : form.idGroup,
      required: form.required,
      idPoll: pollSelected
    }

    setIsLoading(true)
    try {
      const response = await saveQuestionByPoll(data);
      if (response) {
        setForm({
          question: "",
          idComponent: 0,
          idGroup: 0,
          required: false,
        });
        const responseQuestions = await getQuestionsByPoll(pollSelected)
        setQuestions(responseQuestions)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDelete = async () => {
    setModalConfirm(false)
    setIsLoading(true)
    try {
      const response = await deleteQuestion(idSelected);
      if (response) {
        const responseQuestions = await getQuestionsByPoll(pollSelected)
        setQuestions(responseQuestions)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIdSelected(0)
      setIsLoading(false)
    }
  }

  if (isLoading) return <Loader />
  return (
    <>
      <label className="text-[#909090] font-bold text-lg">Contenido del sondeo</label>
      <div className='h-96 w-full overflow-auto rounded-lg border-2 border-[#747474]'>
        <table className='table-fixed w-full'>
          <thead className='border-b-2 border-[#a2a2a2]'>
            <tr className='text-black font-bold text-center'>
              <th className='w-12'>#</th>
              <th>Pregunta</th>
              <th>Tipo</th>
              <th>Respuesta</th>
              <th>Requerida</th>
              <th>Eliminar</th>
            </tr>
          </thead>

          <tbody className='text-[#aeaeae] text-sm'>
            {/* Renderización de preguntas anteriores */}
            {questions.map((item, index) => (
              <tr key={index} className=' text-center h-[70px] border-b border-[#e5e5e5] text-black'>
                <td className='w-1/12 p-0'>{index + 1}</td>
                <td className='w-5/12 p-0 text-start'>{item.question}</td>
                <td className='w-3/12 p-0'>{item.component}</td>
                <td className='w-3/12 p-0'>{item.group}</td>
                <td className='w-1/12 p-0'>{item.required ? 'Sí' : 'No'}</td>
                <td className='h-[100%] pt-5 p-0 flex justify-center items-center'>
                  <div
                    onClick={() => {
                      setIdSelected(item.id);
                      setModalConfirm(true);
                    }}
                    className="w-10 h-10 text-2xl flex justify-center items-center rounded-lg bg-gray-300 cursor-pointer hover:bg-gray-100 hover:border-black hover:border-2">
                    <MdDelete />
                  </div>
                </td>
              </tr>
            ))}
            <tr className='h-[70px] text-black text-center border-b border-[#e5e5e5]'>
              <td className='w-1/12 p-0'>
                <div className=' w-[90%] h-10 grid items-center border border-[#898989] rounded text-center leading-[25px]'>
                  {questions.length + 1}
                </div>
              </td>
              <td className='w-5/12 p-0 text-start'>
                <Select
                  options={selectOptions}
                  onChange={(optSelected) => setForm({ ...form, question: optSelected.value })}
                  noOptionsMessage={() => "No se encontraron resultados"}
                  placeholder="Selecciona una opción"
                  styles={customStyles}
                />
              </td>
              <td className='w-3/12 p-0'>
                <select 
                  className='h-10 w-[90%] border border-[#898989] rounded text-sm p-0'
                  onChange={({ target }) => {
                    const value = target.value;
                    if (value === "") setIsHaveResponse(false)
                    setForm({ 
                      ...form, 
                      idComponent: value,
                      idGroup : "",
                    })
                    if (value === "") return;

                    const component = components.find(item => item.id === +value);
                    setIsHaveResponse(component?.haveGroupResponse ?? false);
                  }}
                  value={form.idComponent}>
                  <option value={""}>Selecciona una opción</option>
                  {components.map((c, i) => (
                    <option value={c.id} key={i}>{c.name}</option>
                  ))}
                </select>
              </td>
              <td className='w-3/12 p-0'>
                <select className='h-10 w-[90%] border border-[#898989] rounded text-sm p-0'
                  onChange={({ target }) => setForm({ ...form, idGroup: target.value })}
                  value={form.idGroup}
                  disabled={!isHaveResponse}
                >
                  <option value={""}>---</option>
                  {groupOptions.filter(item => item.active).map((a, i) => (
                    <option value={a.id} key={i}>{a.description}</option>
                  ))}
                </select>
              </td>
              <td className='w-1/12 p-0 text-center'>
                <input
                  type='radio'
                  className='h-7 w-7 border border-black'
                  checked={form.required}
                  onClick={() => setForm({ ...form, required: !form.required })}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="w-full flex justify-end pb-4 mt-2">
        <button
          className="h-10 px-4 flex items-center gap-2 text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533] transition-all duration-200"
          onClick={handleSave}
        >
          <FaRegSave className="size-5" />
          <span className="hidden sm:inline">Guardar</span>
        </button>
      </div>
      {
        modalConfirm && (
          <ModalConfirm
            title="Eliminar pregunta"
            description="¿Estás seguro de eliminar esta pregunta?"
            onClose={() => setModalConfirm(false)}
            discardDescription="Cancelar"
            acceptDescription="Aceptar"
            onAcept={() => handleDelete()}
          />
        )
      }
    </>
  )
}

const ModalEditQuestions = ({ isOpen, onClose, pollSelected, titlePoll }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white rounded-xl shadow-lg w-full max-w-7xl h-[60vh] relative transition-all duration-300 transform ${showModal ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
          }`}
      >
        <ModalHeader title={`Sondeo ${titlePoll}`} onClose={onClose} />
        <div className='lg:px-10 sm:px-4 py-4 h-[calc(100%-5rem)] flex flex-col'>
          <div className="flex-grow overflow-y-auto">
            <ModalBody pollSelected={pollSelected} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalEditQuestions